import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is Ionic App Development?",
    answer: `<p>Ionic App development makes use of an open-source UI toolkit to build performant, high-quality mobile apps, desktop apps, and progressive web apps making use of web technologies like HTML, Javascript, and CSS.</p>`,
  },
  {
    question: "Why should I opt for Ionic App Development?",
    answer: `<p>The Ionic framework is considered to be simple and fairly easy to learn for developers, unlike React, Angular, and Vue. Ionic App Development only requires you to develop a code and you can run it everywhere.</p>`,
  },
  {
    question: "How to select an ideal Ionic App Development Company?",
    answer: ` <p>When you are searching for an ideal Ionic development company, you need to give adequate consideration to the overall expertise, skills, and capabilities of the Ionic app development agency you are reaching out to.</p>`,
  },
  {
    question: "Can I use Ionic with Cordova?",
    answer: `<p>If you use Ionic with Cordova, you will be in luck as Ionic with Cordova also builds web assets and provides friendly checks for Android and iOS platforms.</p>`,
  },
  {
    question: "Is Ionic suitable for mobile app development?",
    answer: `<p>Ionic is a link between web and native app development for mobile devices, not merely a framework. With more than 5 million apps developed on its platform since its founding in the year 2013 as an open-source SDK for hybrid mobile apps, Ionic has developed into a potent tool.</p>`,
  },
  {
    question:
      "How to enhance the performance of ionic app development services?",
    answer: ` <p>Here’s how you can enhance the performance of ionic mobile app development services:</p>
    <ul>
    <li>Asynchronous Transfer</li>
    <li>Defining Class Methods</li>
    <li>Defining Collection-Repeat</li>
    <li>Compression</li>
    <li>Content Delivery Networks</li>
    <li>Native Scrolling</li>
    <li>Instance Variance Declaration</li>
    <li>Initialization of JavaScript</li>
    </ul>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#fff" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>
                <span>Ionic App Development Services</span> FAQs
              </h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
